/*
    @author      Holger Schauf
    @title       Tipo Tooltips
    @type        core module
    @description core functions to create tooltips with position and content set

    Examples:
    Tooltip with content from title attribute
    $('.storno').tooltip();

    Tooltip with content from string
    $('.storno').tooltip({
        content: '<h3>headline</h3>'
    });

    Tooltip with content from template
    $('.storno').tooltip({
        template: 'templateID'
    '});

    Tooltip with content from function
    $('.storno').tooltip({
        content: function();
    '});

    Set a Sticky Tooltip with sticky: true to get a sticky with close button
    $('.storno').tooltip({
        sticky: true
    });

     Build Tooltip Content on INIT
     $('.storno').tooltip({
        preBuild: true,
     });
 */
var delayed = true;
var next = false;

var dontHideTips = false;
var tipoList = {};

if (typeof mobile === 'undefined') {
    var mobile = false;
}

var tipoDefaultClasses = tipoDefaultClasses || '';

var Tipo = (function ($) {
    return Class.extend({
        body: $('body'),
        tip: null,
        content: null,
        avoidPos: 'bottom',
        id: new Date().getTime(),
        title: false,
        openTime: null,

        init: function (elm, cfg) {
            var settings = {
                position: 'bottom',
                width: 'auto',
                left: 0,
                top: 0,
                margin: 12,
                topMargin: 0,
                leftMargin: 0,
                rightMargin: 0,
                data: {},
                content: '',
                template: false,
                tmpl: false,
                addClass: ' ',
                type: 'default',
                arrow: true,
                arrowTop: 0,
                arrowLeft: 0,
                sticky: false,
                fetchScript: '',
                callback: false,
                closeButton: false,
                preBuild: false,
                closeDelay: false,
                openDelay: 300,
                gaPush: false,
                focusByDarkBackground: false,
                specialTooltip: false,
                arrowPosition: false,
                special: false,
                allowArrowStyle: false,
            };

            this.cfg = Object.assign({}, settings, cfg);
            this.elm = elm;
            this.behind_background = null;
            this.sticky = false;

            if (mobile === true) {
                this.cfg.sticky = true;
                this.cfg.closeButton = true;
            }

            if (typeof this.setEvents === 'function') {
                this.setEvents(this);
            }

            if (
                this.cfg.special === 'showOnLoad' &&
                $(this.elm).is(':visible')
            ) {
                this.showAfterSeconds(this, 3);
                this.hideAfterSeconds(this, 11);
            }

            if (this.cfg.preBuild === true) {
                this.buildTip(this);
            }
        },

        toggle: function () {
            if (this.tip === null) {
                this.showTooltip(this);
                return false;
            }

            this.tip.is(':visible') && (this.sticky === false || mobile)
                ? this.hideTooltip(this)
                : this.showTooltip(this);
        },

        postBuildHook: function () {
            if (this.cfg.fetchScript.length > 0) {
                this.fetchScript(this.cfg.fetchScript);
            }
        },
    });
})(jQuery);

Tipo.prototype.source = function (self) {
    var $tpl = $('#' + self.cfg.template);

    // used in debug mode
    // normalize tip content source
    if (self.cfg.tmpl !== false && typeof $.tmpl !== 'undefined') {
        if ($('#' + self.cfg.tmpl).length > 0) {
            self.content = $.tmpl($('#' + self.cfg.tmpl), self.cfg.data).html();
        }
    } else if (self.cfg.content === '' && self.cfg.template === false) {
        if (
            $(self.elm).attr('title') === undefined ||
            $(self.elm).attr('title') === ''
        ) {
            return false;
        }

        self.content = '<p>' + $(self.elm).attr('title') + '</p>';

        self.title = true;

        $(self.elm).removeAttr('title');
    } else if (typeof self.cfg.content === 'function') {
        self.cfg.content = self.cfg.content();

        if ($tpl.length === 0) {
            return false;
        }

        for (var i in self.cfg.content) {
            $tpl.find(i).html(self.cfg.content[i]);
        }

        self.content = $tpl.html();
    } else if (self.cfg.template !== false) {
        if ($tpl.length === 0) {
            return false;
        }

        self.content = $tpl.html();
    } else {
        if (self.cfg.content === undefined) {
            return false;
        }

        self.content = self.cfg.content;
    }

    if (self.content === null) {
        return false;
    }
};

Tipo.prototype.hideTooltip = function (self) {
    if (dontHideTips === true) {
        return false;
    }

    // remove tip von openList;
    tipoList[self.id] = null;
    delete tipoList[self.id];

    if (self.behind_background) {
        self.behind_background
            .stop(true)
            .animate({ opacity: 0 }, 500, function () {
                if (typeof stj.loadResults !== 'undefined') {
                    stj.loadResults.resume();
                }
            });
    }

    $('#' + self.id)
        .hide()
        .remove();

    self.sticky = false;
};

Tipo.prototype.fetchScript = function (scripts) {
    if (!Array.isArray(scripts)) {
        scripts = [scripts];
    }
    for (var i = 0; i <= scripts.length; i++) {
        $.getScript(scripts[i]);
    }
};

Tipo.prototype.showAfterSeconds = function (self, seconds) {
    setTimeout(function () {
        self.showTooltip(self);
    }, seconds * 1000);
};

Tipo.prototype.hideAfterSeconds = function (self, seconds) {
    setTimeout(function () {
        self.hideTooltip(self);
    }, seconds * 1000);
};

Tipo.prototype.preventer = false;

var TipoBuild = function (el, cfg) {
    if (el.data('tooltip') === undefined) {
        var tip = new Tipo(el, cfg);
        //layerList[(new Date()).getTime()] = tip;
        el.data('tooltip', tip);
    }
};

var TipoHideAll = function () {
    if (Object.keys(tipoList).length === 0) {
        var $tooltip = $('.tooltip');
        if ($tooltip.length > 0) {
            $tooltip.remove();
        }
        return;
    }

    for (var tip in tipoList) {
        tipoList[tip].hideTooltip(tipoList[tip]);
    }
};

var TipoInitByAttr = function (context) {
    var tipos = jQuery('[tipo]', context !== undefined ? context : '');

    tipos.each(function () {
        var data = jQuery(this).attr('tipo');
        if (data) {
            TipoBuild(jQuery(this), JSON.parse(data));
        }
    });
};

var TipoInitSingle = function (el) {
    var data = el.attr('tipo');
    if (data) {
        TipoBuild(el, JSON.parse(data));
    }
};

(function ($) {
    $.fn.tooltip = function (cfg) {
        return this.each(function () {
            TipoBuild($(this), cfg);
        });
    };
})(jQuery);

jQuery(document).ready(function () {
    TipoInitByAttr();
});
